/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Canvas_Sign_In_FailedInputs */



/**
* | output |
* | --- |
* | "Could not send the sign-in link. Please try again." |
*
* @param {Canvas_Sign_In_FailedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const canvas_sign_in_failed = /** @type {((inputs?: Canvas_Sign_In_FailedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Canvas_Sign_In_FailedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Anmeldelink konnte nicht gesendet werden. Bitte versuchen Sie es erneut.")
	return /** @type {LocalizedString} */ ("Could not send the sign-in link. Please try again.")
});